import { useContext, createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const AuthContext = createContext();

const parseJwt = (token) => {
    if (token === "") {
        return {
            upn: "",
            groups: [],
        };
    } else {
        let json = atob(token.split(".")[1]);
            let jsonObject = JSON.parse(json);
            return jsonObject;
    }
};

const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(sessionStorage.getItem("site") || "");
  const [game, setGame] = useState(sessionStorage.getItem("game") || undefined);
  const jwtUser = parseJwt(token);
  const [user, setUser] = useState(jwtUser.upn || "");
  const [roles, setRoles] = useState(jwtUser.groups || []);
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const loginAction = async (data) => {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const data = await response.json();
        let usr = parseJwt(data.token);
        setUser(usr.upn);
        setRoles(usr.groups);
        setToken(data.token);
        sessionStorage.setItem("site", data.token);
        sessionStorage.setItem("locale", data.locale);
        i18n.changeLanguage(data.locale);
        navigate("/games");
        return;
      } else {
        console.log(response);
        return response;
      }
  };
  const gameLoginAction = async (data) => {
      const response = await fetch("/api/game-login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const data = await response.json();
        const game = data.game;
        let usr = parseJwt(data.token);
        setUser(usr.upn);
        setRoles(usr.groups);
        setToken(data.token);
        sessionStorage.setItem("site", data.token);
        sessionStorage.setItem("locale", data.locale);
        sessionStorage.setItem("game", game);
        sessionStorage.setItem("team", data.team);
        i18n.changeLanguage(data.locale);
        navigate(`/games/${game}`);
        return;
      } else {
        console.log(response);
        return response;
      }
  };

  const logOut = () => {
    setUser("");
    setRoles([]);
    setToken("");
    sessionStorage.removeItem("site");
    sessionStorage.removeItem("game");
    const redirectUrl = game ? "/game-login" : "/login";
    navigate(redirectUrl);
  };

  return (
    <AuthContext.Provider value={{ token, user, roles, loginAction, gameLoginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );

};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};